{
	"blockedPlace": "El local {{placeName}} está bloqueado",
	"blockedPlaces": "Los locales {{placeName}} están bloqueado",
	"certificatesAboutToExpire": "Los certificados digitales {{value}} del perfil de caducará en 30 días!",
	"expiredCertificates": "Los certificados digitales {{value}} han caducado!",
	"isApproved": "¡Atención! Este local está en estado de preaprobación, no será posible abrir eventos hasta que se realice la aprobación..",
	"requests_one": "¡Atención! Usted tiene {{value}} solicitudes de retiro de proveedores pendientes",
	"requests_other": "¡Atención! Usted tiene {{value}} Solicitudes de retiro de proveedores pendientes"
}
